<template lang="pug">
  .cashFlowChart
    highcharts(
      :options="options"
      :updateArgs="updateArgs"
      ref="chart"
    )

</template>

<script>
import { Chart } from 'highcharts-vue'
import Highcharts from 'highcharts'
import More from 'highcharts/highcharts-more'
More(Highcharts)

export default {
  name: 'CashFlowChart',
  props: {
    data: {},
    height: {},
    width: {},
    exchangeRate: {}
  },
  data: function () {
    return {
      updateArgs: [true, true, { duration: 1000 }]
    }
  },
  components: {
    highcharts: Chart
  },
  computed: {
    options () {
      return {
        chart: {
          animation: true,
          width: this.width,
          height: this.height
        },
        title: {
          text: ''
        },
        legend: {
          enabled: true
        },
        xAxis: {
          categories: this.data.labels
        },
        yAxis: [{
          // Primary
          labels: {
            formatter: function () {
              return '$' + this.value.toLocaleString()
            }
          },
          title: {
            text: 'Annual Cash Flow ($ 000)'
          }
        }
        ],
        tooltip: {
          followPointer: true,
          shared: true,
          valueDecimals: 0
        },
        plotOptions: {
          column: {
            stacking: 'normal'
          }
        },
        credits: {
          enabled: false
        },
        series: [
          {
            name: 'Capital Cost',
            type: 'column',
            color: '#b8d9eb',
            data: this.data.capitalCost.map((x) => {
              return x * this.exchangeRate
            })
          },
          {
            name: 'Operating Cash Flow',
            type: 'column',
            color: '#cedbb4',
            data: this.data.operatingCashFlow.map((x) => {
              return x * this.exchangeRate
            })
          },
          {
            name: 'Free Cash Flow',
            type: 'spline',
            color: '#a8bfac',
            data: this.data.freeCashFlow.map((x) => {
              return x * this.exchangeRate
            }),
            yAxis: 0

          }
        ]
      }
    }
  }
}
</script>

<style scoped>

</style>
